import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageComponent } from './language.component';
import { LanguageService } from './language.service';
import { throwIfAlreadyLoaded } from '../guards/module-import-guard';
import { TRANSLATION_PROVIDERS } from './translations/translations';

@NgModule({
  declarations: [LanguageComponent],
  imports: [
    CommonModule
    ],
    exports: [LanguageComponent],
    providers: [LanguageService, TRANSLATION_PROVIDERS]
})
export class LanguageModule {
    constructor(@Optional() @SkipSelf() parentModule: LanguageModule) {
        throwIfAlreadyLoaded(parentModule, 'LanguageModule');
    }
}
